exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".salary-float[data-v-1fe7bbcc]{float:right}", "", {"version":3,"sources":["/workspace/src/views/question-review/components/ReviewBox/src/CustomSalary.vue"],"names":[],"mappings":"AACA,+BAA+B,WAAW,CACzC","file":"CustomSalary.vue","sourcesContent":["\n.salary-float[data-v-1fe7bbcc]{float:right\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1fe7bbcc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/question-review/components/ReviewBox/src/CustomSalary.vue
// module id = 2239
// module chunks = 5 34